<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<template>
  <div>
    <div class="half-angle bg-white margin padding">
   <div class="text-center text-black "> 剩余支付时间</div>
   <div class="text-center text-orange text-bold text-xl ">10:00:00</div>
   <!-- <div class="text-center text-orange text-bold text-xl ">{{countdown}}</div> -->
</div>
<div class="half-angle bg-white margin padding" style="text-align: left;">
   <div class="flex">
      <div class="text-black text-bold text-xl "><text class="text-bold text-orange">*</text> 手机号</div>
      <input class="text-black text-xl margin-left-xl" :value="userPhone" placeholder="请输入手机号"/>
   </div>
   <div class="margin-top-xs " style="color: #ff6600;">手机号仅用于完成购买使用</div>
</div>
<div class="half-angle bg-white margin padding" style="text-align: left;">
   <div class="text-black text-bold padding-bottom-sm b-b text-cut text-xl "><text class="text-bold text-orange">*</text> {{goodsName}}</div>
   <div class="margin-top-sm text-cut" style="color: #ff6600;">{{values}}</div>
   <div class=" text-black text-bold  padding-top-sm " >{{valueKey}}</div>
</div>
<!-- 购买按钮 -->
<div class="padding padding-bottom-xl flex align-center justify-between" style="position: fixed;bottom: 0;width: 100%;background-color: white; letter-spacing: 2px;">
   <div class="text-orange text-xxl text-bold text-bold">￥{{price/100}}</div>
   <div class="an_shop text-bold">确认支付</div>
</div>
</div>
</template>
<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'buyYx',
  data () {
    return {
      // requestHeadUrl: 'https://zhenqing.kequbang.com',
      requestHeadUrl: 'http://localhost:8122',
      isOpenVipModular: false,
      showModal: false, // 是否展示弹窗
      isVip: 0,
      storeId: '',
      userId: '',
      isMiniProgram: true,
      appLink: '',
      info: {},
      goodsAttributes: [],
      TabCur:0,
      modalName: '',
      goodsName: '',
      title: '',
      values: '',
      valueKey: '',
      price: '',
      userPhone: ''
    }
  },
  created () {
    const thisObj = this
    let params = this.$route.query;
    thisObj.goodsName = params.goodsName,
    thisObj.title = params.title,
    thisObj.values = params.values,
    thisObj.valueKey = params.valueKey,
    thisObj.price = params.price,
    thisObj.userPhone = ''
    // const thisObj = this
    // thisObj.onLoad()
  },
  methods: {
    onLoad: function () {
      // const payParam = {
      //       appId: 'wxa55c200673db6dc7',
      //       package: 'result.resultData.package',
      //       paySign: 'result.resultData.sign',
      //       signType: 'MD5',
      //       timeStamp: 'result.resultData.timeStamp',
      //       nonceStr: 'result.resultData.nonceStr'
      //     }
      // this.navigateToMiniProgram(JSON.stringify(payParam))
      var rr = window.location.href.split('/')
      //9d03442a91c345709dcbcd85daab9cc4
      var gid = rr[rr.length-1].split('-')[0]
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/p/goods/getByGoodId?goodId='+ gid +'&storeId=storezhenqing&linkId='+rr[rr.length-1], {}).then(res => {
        // console.log(res)
        res.goodsImgs = res.goodsImgs.split(",");
        res.goodsDetailImgs = res.goodsDetailImgs.split(",");
        thisObj.info = res 
        thisObj.goodsAttributes = JSON.parse(res.goodsAttributes)
        // console.log(thisObj.info)
        // console.log(thisObj.goodsAttributes)
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
      
      // thisObj.$api.get(thisObj.requestUrl + '/auth/knowledge/dy/app/openlink?fromDevice=h5&knowledgeOpenPersonId=1', {}).then(res => {
      //   // console.log(res)
      //   if (res.resultCode === 200 && res.success) {
      //     console.log(res) 
      //   } else {
      //     thisObj.$util.requetServerError(res.resultMsg)
      //   }
      // }).catch(function (error) {
      //   thisObj.$util.requetServerError(error)
      // })
      // thisObj.$api.get(thisObj.requestUrl + '/auth/knowledge/dy?fromDevice=h5&knowledgeOpenPersonId=1', {}).then(res => {
      //   // console.log(res)
      //   if (res.resultCode === 200 && res.success) {
      // // location.href=res.resultData.openlink;
      //     wx.config({
      //       debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印
      //       appId: 'wxa55c200673db6dc7', // 必填，公众号的唯一标识
      //       timestamp: res.resultData.timestamp, // 必填，生成签名的时间戳
      //       nonceStr: res.resultData.nonceStr, // 必填，生成签名的随机串
      //       signature: res.resultData.signature,// 必填，签名
      //       jsApiList: ['onMenuShareTimeline'], // 必填，需要使用的 JS 接口列表
      //       openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      //     });
      //     wx.ready(function () {
      //       console.log('ok')
      //       // config信息验证后会执行 ready 方法，所有接口调用都必须在 config 接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在 ready 函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在 ready 函数中
      //     });
      //     wx.error(function (res) {
      //       alert(res)
      //       // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名
      //       console.log('error')
      //       console.log(res)
      //     });
      //   } else {
      //     thisObj.$util.requetServerError(res.resultMsg)
      //   }
      // }).catch(function (error) {
      //   thisObj.$util.requetServerError(error)
      // })
      // return
    },
    goApp() {
      location.href=this.appLink
    },
    tabSelect(e) {
      this.TabCur = e
    },
    // 页面跳转
    pageJump (uri, item) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    
  }
}
</script>

<style>
.bg-e {
  background: #eeeeee;
}
.margin-top {
    margin-top: 30px;
}
.grid {
    display: flex;
    flex-wrap: wrap;
}
.justify-between {
    justify-content: space-between;
}
.align-center {
    align-items: center;
}
.text-xxl {
    font-size: 44px;
}
.margin {
    margin: 30px;
}
.half-angle {
    box-shadow: 1rpx 2rpx 18rpx 0rpx rgba(0, 0, 0, 0.12);
    border-radius: 40rpx;
}
.bg-white {
    background-color: var(--white);
    color: var(--darkGray);
}
.padding {
    padding: 30px;
}
.text-cut {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.text-xl {
    font-size: 36px;
}
.flex {
    display: flex;
}
.grid.col-2>div {
    width: 50%;
}
.text-orange, .line-orange, .lines-orange {
    color: var(--orange);
}
.text-center {
    text-align: center;
}
.text-bold {
    font-weight: bold;
}
.text-xl {
    font-size: 36px;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding {
    padding: 30px;
}
.padding-top {
    padding-top: 30px;
}
.b-b {
    border-bottom: 2px solid #CFCFCF;
}
.padding-sm {
    padding: 20px;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.text-bold {
    font-weight: bold;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}

.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}

.shuxing {
  color: #ff6600;
  font-size: 33px;
  width: 29%;
  margin: 12px;
  border-radius: 20px;
  padding: 20px 8px;
  margin-top: 30px;
  background-color: #ffefe4;
  border: 2px solid #ff6600;
}
.an_shop {
  width: 40%;
  line-height: 80px;
  color: #fff;
  background-color: #ff6600;
  border-radius: 50px;
  text-align: center;
  font-size: 36px;
}
.half-angle {
    box-shadow: 1px 2px 18px 0px rgba(0, 0, 0, 0.12);
    border-radius: 40px;
}
.margin-top-sm {
    margin-top: 20px;
}
.margin-top-xs {
    margin-top: 10px;
}
.padding-top-sm {
    padding-top: 20px;
}
</style>
